import React from "react";

export default function MenuMiniatures({items, selected, onClick}) {

    const normalClass = {
        height:"50px", 
       // border:"2px solid var(--miniature-selected)",
        borderRadius:"10px"
    }
    const selectedClass = {
        height:"50px", 
        border:"2px solid var(--miniature-selected)",
        borderRadius:"10px"
    }
    return(
        <div style={{position:"absolute", right:"0px", bottom:"10px", width:"auto", 
        height:"70px", backgroundColor:"var(--black-color-90)", borderRadius:"10px 0px 0px 10px",
        display:"flex", alignItems:"center", justifyContent:"center", boxSizing:"border-box", 
        paddingLeft:"15px", paddingRight:"15px"}}>
            <ul style={{padding:"0px", margin:"0px", height:"54px", display:"flex", 
            listStyle:"none"}}>      
            {
                items.map((item, index)=> {
                    return (
                    <li key={item.id} image={item.image} 
                        onClick={()=>onClick(index)}
                        style={{height:"100%", aspectRatio:"16/9", cursor:"pointer"}}>
                        <img src={item.image} style={selected === index ? selectedClass:normalClass} />
                    </li>
                    )
                })
            }                
            </ul>
        </div>
    );
}
